import React from 'react';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';
import PropTypes from 'prop-types';
// 碎片组件
import Chip from 'Chip';
// 组件
import Nav from '../Nav';
import Content from './Content';

const Speech = ({ content }) => {

const { speech, speechTitle } = content;

return (
        <div className={styles.wrap}>
                   
                    <Chip 
                        key="speechTitle"
                        id="260156"
                        name="speechTitle"
                        type="struct"
                        title="名家言论标题"
                        groupName="名家言论标题"
                        content={speechTitle}
                    >
                            <Nav />
                    </Chip>

                    <Chip 
                        key="speech"
                        id="285746"
                        name="speech"
                        type="recommend"
                        title="名家言论"
                        groupName="名家言论"
                        content={speech}
                    >
                        <Content />
                    </Chip>
 
        </div>
    );
};

Speech.propTypes = {
    content: PropTypes.object,
};
export default errorBoundary(Speech);

